import { useParams } from 'react-router-dom';
import { JOIN_METHOD_ID_KEY } from '../lib/constants';

export function useJoinMethodId(): string {
  return useParams<{[ JOIN_METHOD_ID_KEY ]: string}>()[JOIN_METHOD_ID_KEY];
}
